export const data = [
  ['MQU_1COV_DE_TR_INDEX', 'Covestro AG', '1COV.DE', '1COV'],
  ['MQU_A2_MI_TR_INDEX', 'A2A S.p.A.', 'A2.MI', 'A2A'],
  ['MQU_ABBN_S_TR_INDEX', 'ABB Ltd.', 'ABBN.S', 'ABBN'],
  ['MQU_ABI_BR_TR_INDEX', 'Anheuser-Busch InBev SA/NV', 'ABI.BR', 'ABI'],
  ['MQU_ACS_MC_TR_INDEX', 'ACS Actividades de Construccion y Servicios SA', 'ACS.MC', 'ACS'],
  ['MQU_ACX_MC_TR_INDEX', 'Acerinox SA', 'ACX.MC', 'ACX'],
  ['MQU_AD_AS_TR_INDEX', 'Koninklijke Ahold Delhaize N.V.', 'AD.AS', 'AD'],
  ['MQU_ADSGn_DE_TR_INDEX', 'adidas AG', 'ADSGn.DE', 'ADS'],
  ['MQU_ADYEN_AS_TR_INDEX', 'Adyen NV', 'ADYEN.AS', 'ADYEN'],
  ['MQU_AENA_MC_TR_INDEX', 'Aena SME SA', 'AENA.MC', 'AENA'],
  ['MQU_AIR_PA_TR_INDEX', 'Airbus SE', 'AIR.PA', 'AIR'],
  ['MQU_AIRP_PA_TR_INDEX', "L'Air Liquide S.A.", 'AIRP.PA', 'AI'],
  ['MQU_ALCC_S_TR_INDEX', 'Alcon AG', 'ALCC.S', 'ALC'],
  ['MQU_ALFA_ST_TR_INDEX', 'Alfa Laval AB', 'ALFA.ST', 'ALFA'],
  ['MQU_ALIVsdb_ST_TR_INDEX', 'Autoliv Inc Shs Swedish DR', 'ALIVsdb.ST', 'ALIV'],
  ['MQU_ALVG_DE_TR_INDEX', 'Allianz SE', 'ALVG.DE', 'ALV'],
  ['MQU_AMA_MC_TR_INDEX', 'Amadeus IT Group SA Class A', 'AMA.MC', 'AMS'],
  ['MQU_AMPF_MI_TR_INDEX', 'Amplifon S.p.A.', 'AMPF.MI', 'AMP'],
  ['MQU_ANA_MC_TR_INDEX', 'Acciona SA', 'ANA.MC', 'ANA'],
  ['MQU_ANE_MC_TR_INDEX', 'Corporacion Acciona Energias Renovables SA', 'ANE.MC', 'ANE'],
  ['MQU_ASSAb_ST_TR_INDEX', 'ASSA ABLOY AB Class B', 'ASSAb.ST', 'ASSAB'],
  ['MQU_ATCOa_ST_TR_INDEX', 'Atlas Copco AB Class A', 'ATCOa.ST', 'ATCOA'],
  ['MQU_ATCOb_ST_TR_INDEX', 'Atlas Copco AB Class B', 'ATCOb.ST', 'ATCOB'],
  ['MQU_AXAF_PA_TR_INDEX', 'AXA SA', 'AXAF.PA', 'CS'],
  ['MQU_AZMT_MI_TR_INDEX', 'Azimut Holding Spa', 'AZMT.MI', 'AZM'],
  ['MQU_AZN_L_TR_INDEX', 'AstraZeneca PLC', 'AZN.L', 'AZN'],
  ['MQU_BAMI_MI_TR_INDEX', 'Banco BPM SpA', 'BAMI.MI', 'BAMI'],
  ['MQU_BASFn_DE_TR_INDEX', 'BASF SE', 'BASFn.DE', 'BAS'],
  ['MQU_BAYGn_DE_TR_INDEX', 'Bayer AG', 'BAYGn.DE', 'BAYN'],
  ['MQU_BBVA_MC_TR_INDEX', 'Banco Bilbao Vizcaya Argentaria, S.A.', 'BBVA.MC', 'BBVA'],
  ['MQU_BEIG_DE_TR_INDEX', 'Beiersdorf AG', 'BEIG.DE', 'BEI'],
  ['MQU_BKT_MC_TR_INDEX', 'Bankinter SA', 'BKT.MC', 'BKT'],
  ['MQU_BMED_MI_TR_INDEX', 'Banca Mediolanum SpA', 'BMED.MI', 'BMED'],
  ['MQU_BMWG_DE_TR_INDEX', 'Bayerische Motoren Werke AG', 'BMWG.DE', 'BMW'],
  ['MQU_BNPP_PA_TR_INDEX', 'BNP Paribas S.A. Class A', 'BNPP.PA', 'BNP'],
  ['MQU_BNRGn_DE_TR_INDEX', 'Brenntag Societas Europaea', 'BNRGn.DE', 'BNR'],
  ['MQU_BOL_ST_TR_INDEX', 'Boliden AB', 'BOL.ST', 'BOL'],
  ['MQU_BOUY_PA_TR_INDEX', 'Bouygues SA', 'BOUY.PA', 'EN'],
  ['MQU_BZU_MI_TR_INDEX', 'Buzzi Spa', 'BZU.MI', 'BZU'],
  ['MQU_CABK_MC_TR_INDEX', 'CaixaBank SA', 'CABK.MC', 'CABK'],
  ['MQU_CAPP_PA_TR_INDEX', 'Capgemini SE', 'CAPP.PA', 'CAP'],
  ['MQU_CARR_PA_TR_INDEX', 'Carrefour SA', 'CARR.PA', 'CA'],
  ['MQU_CBKG_DE_TR_INDEX', 'Commerzbank AG', 'CBKG.DE', 'CBK'],
  ['MQU_CFR_S_TR_INDEX', 'Compagnie Financiere Richemont SA', 'CFR.S', 'CFR'],
  ['MQU_CGCBV_HE_TR_INDEX', 'Cargotec Oyj Class B', 'CGCBV.HE', 'CGCBV'],
  ['MQU_CLNX_MC_TR_INDEX', 'Cellnex Telecom S.A.', 'CLNX.MC', 'CLNX'],
  ['MQU_CNHI_MI_TR_INDEX', 'CNH Industrial NV', 'CNHI.MI', 'CNHI'],
  ['MQU_COL_MC_TR_INDEX', 'Inmobiliaria Colonial SOCIMI SA', 'COL.MC', 'COL'],
  ['MQU_CONG_DE_TR_INDEX', 'Continental AG', 'CONG.DE', 'CON'],
  ['MQU_CPRI_MI_TR_INDEX', 'Davide Campari-Milano N.V.', 'CPRI.MI', 'CPR'],
  ['MQU_CRDI_MI_TR_INDEX', 'UniCredit S.p.A.', 'CRDI.MI', 'UCG'],
  ['MQU_DANO_PA_TR_INDEX', 'Danone SA', 'DANO.PA', 'BN'],
  ['MQU_DAST_PA_TR_INDEX', 'Dassault Systemes SA', 'DAST.PA', 'DSY'],
  ['MQU_DB1Gn_DE_TR_INDEX', 'Deutsche Boerse AG', 'DB1Gn.DE', 'DB1'],
  ['MQU_DBKGn_DE_TR_INDEX', 'Deutsche Bank Aktiengesellschaft', 'DBKGn.DE', 'DBK'],
  ['MQU_DHLn_DE_TR_INDEX', 'Deutsche Post AG', 'DHLn.DE', 'DHL'],
  ['MQU_DIAS_MI_TR_INDEX', 'DiaSorin S.p.A.', 'DIAS.MI', 'DIA'],
  ['MQU_DTEGn_DE_TR_INDEX', 'Deutsche Telekom AG', 'DTEGn.DE', 'DTE'],
  ['MQU_DTGGe_DE_TR_INDEX', 'Daimler Truck Holding AG', 'DTGGe.DE', 'DTG'],
  ['MQU_ELE_MC_TR_INDEX', 'Endesa S.A.', 'ELE.MC', 'ELE'],
  ['MQU_ELISA_HE_TR_INDEX', 'Elisa Oyj Class A', 'ELISA.HE', 'ELISA'],
  ['MQU_ELUXb_ST_TR_INDEX', 'Electrolux AB Class B', 'ELUXb.ST', 'ELUXB'],
  ['MQU_EMII_MI_TR_INDEX', 'BPER Banca S.p.A.', 'EMII.MI', 'BPE'],
  ['MQU_ENAG_MC_TR_INDEX', 'Enagas SA', 'ENAG.MC', 'ENG'],
  ['MQU_ENEI_MI_TR_INDEX', 'Enel SpA', 'ENEI.MI', 'ENEL'],
  ['MQU_ENGIE_PA_TR_INDEX', 'ENGIE SA.', 'ENGIE.PA', 'ENGI'],
  ['MQU_ENI_MI_TR_INDEX', 'Eni S.p.A.', 'ENI.MI', 'ENI'],
  ['MQU_ENR1n_DE_TR_INDEX', 'Siemens Energy AG', 'ENR1n.DE', 'ENR'],
  ['MQU_EONGn_DE_TR_INDEX', 'E.ON SE', 'EONGn.DE', 'EOAN'],
  ['MQU_ERG_MI_TR_INDEX', 'ERG S.p.A.', 'ERG.MI', 'ERG'],
  ['MQU_ERICb_ST_TR_INDEX', 'Telefonaktiebolaget LM Ericsson Class B', 'ERICb.ST', 'ERICB'],
  ['MQU_ESLX_PA_TR_INDEX', 'EssilorLuxottica SA', 'ESLX.PA', 'EL'],
  ['MQU_ESSITYb_ST_TR_INDEX', 'Essity AB Class B', 'ESSITYb.ST', 'ESSITYB'],
  ['MQU_EUFI_PA_TR_INDEX', 'Eurofins Scientific SE', 'EUFI.PA', 'ERF'],
  ['MQU_EVOG_ST_TR_INDEX', 'Evolution AB', 'EVOG.ST', 'EVO'],
  ['MQU_FBK_MI_TR_INDEX', 'FinecoBank SpA', 'FBK.MI', 'FBK'],
  ['MQU_FER_MC_TR_INDEX', 'Ferrovial SE', 'FER.MC', 'FER'],
  ['MQU_FLUI_MC_TR_INDEX', 'Fluidra, S.A.', 'FLUI.MC', 'FDR'],
  ['MQU_FORTUM_HE_TR_INDEX', 'Fortum Oyj', 'FORTUM.HE', 'FORTUM'],
  ['MQU_FREG_DE_TR_INDEX', 'Fresenius SE & Co. KGaA', 'FREG.DE', 'FRE'],
  ['MQU_GASI_MI_TR_INDEX', 'Assicurazioni Generali S.p.A.', 'GASI.MI', 'G'],
  ['MQU_GEBN_S_TR_INDEX', 'Geberit AG', 'GEBN.S', 'GEBN'],
  ['MQU_GETIb_ST_TR_INDEX', 'Getinge AB Class B', 'GETIb.ST', 'GETIB'],
  ['MQU_GIVN_S_TR_INDEX', 'Givaudan SA', 'GIVN.S', 'GIVN'],
  ['MQU_GRLS_MC_TR_INDEX', 'Grifols, S.A. Class A', 'GRLS.MC', 'GRF'],
  ['MQU_HEIG_DE_TR_INDEX', 'Heidelberg Materials AG', 'HEIG.DE', 'HEI'],
  ['MQU_HEXAb_ST_TR_INDEX', 'Hexagon AB Class B', 'HEXAb.ST', 'HEXAB'],
  ['MQU_HMb_ST_TR_INDEX', 'H&M Hennes & Mauritz AB Class B', 'HMb.ST', 'HMB'],
  ['MQU_HNKG_p_DE_TR_INDEX', 'Henkel AG & Co. KGaA Pref', 'HNKG_p.DE', 'HEN3'],
  ['MQU_HNRGn_DE_TR_INDEX', 'Hannover Rueck SE', 'HNRGn.DE', 'HNR1'],
  ['MQU_HOLN_S_TR_INDEX', 'Holcim Ltd', 'HOLN.S', 'HOLN'],
  ['MQU_HRA_MI_TR_INDEX', 'Hera S.p.A.', 'HRA.MI', 'HER'],
  ['MQU_HRMS_PA_TR_INDEX', 'Hermes International SCA', 'HRMS.PA', 'RMS'],
  ['MQU_HUH1V_HE_TR_INDEX', 'Huhtamaki Oyj', 'HUH1V.HE', 'HUH1V'],
  ['MQU_IBE_MC_TR_INDEX', 'Iberdrola SA', 'IBE.MC', 'IBE'],
  ['MQU_IDR_MC_TR_INDEX', 'Indra Sistemas, S.A. Class A', 'IDR.MC', 'IDR'],
  ['MQU_IFXGn_DE_TR_INDEX', 'Infineon Technologies AG', 'IFXGn.DE', 'IFX'],
  ['MQU_IG_MI_TR_INDEX', 'Italgas SpA', 'IG.MI', 'IG'],
  ['MQU_INGA_AS_TR_INDEX', 'ING Groep NV', 'INGA.AS', 'INGA'],
  ['MQU_INVEb_ST_TR_INDEX', 'Investor AB Class B', 'INVEb.ST', 'INVEB'],
  ['MQU_INWT_MI_TR_INDEX', 'Infrastrutture Wireless Italiane S.p.A.', 'INWT.MI', 'INW'],
  ['MQU_ISP_MI_TR_INDEX', 'Intesa Sanpaolo S.p.A.', 'ISP.MI', 'ISP'],
  ['MQU_ITPG_MI_TR_INDEX', 'Interpump Group S.p.A.', 'ITPG.MI', 'IP'],
  ['MQU_ITX_MC_TR_INDEX', 'Industria de Diseno Textil, S.A.', 'ITX.MC', 'ITX'],
  ['MQU_IVG_MI_TR_INDEX', 'Iveco Group NV', 'IVG.MI', 'IVG'],
  ['MQU_KCRA_HE_TR_INDEX', 'Konecranes Oyj', 'KCRA.HE', 'KCR'],
  ['MQU_KESKOB_HE_TR_INDEX', 'Kesko Oyj Class B', 'KESKOB.HE', 'KESKOB'],
  ['MQU_KINVb_ST_TR_INDEX', 'Kinnevik AB Class B', 'KINVb.ST', 'KINVB'],
  ['MQU_KNEBV_HE_TR_INDEX', 'Kone Oyj Class B', 'KNEBV.HE', 'KNEBV'],
  ['MQU_KNIN_S_TR_INDEX', 'Kuehne & Nagel International AG', 'KNIN.S', 'KNIN'],
  ['MQU_KOJAMO_HE_TR_INDEX', 'Kojamo Oyj', 'KOJAMO.HE', 'KOJAMO'],
  ['MQU_LDOF_MI_TR_INDEX', 'Leonardo SpA', 'LDOF.MI', 'LDO'],
  ['MQU_LEGD_PA_TR_INDEX', 'Legrand SA', 'LEGD.PA', 'LR'],
  [
    'MQU_LOG_MC_TR_INDEX',
    'Compania de Distribucion Integral Logista Holdings S.A.',
    'LOG.MC',
    'LOG',
  ],
  ['MQU_LOGN_S_TR_INDEX', 'Logitech International S.A.', 'LOGN.S', 'LOGN'],
  ['MQU_LONN_S_TR_INDEX', 'Lonza Group AG', 'LONN.S', 'LONN'],
  ['MQU_LVMH_PA_TR_INDEX', 'LVMH Moet Hennessy Louis Vuitton SE', 'LVMH.PA', 'MC'],
  ['MQU_MAP_MC_TR_INDEX', 'Mapfre SA', 'MAP.MC', 'MAP'],
  ['MQU_MBGn_DE_TR_INDEX', 'Mercedes-Benz Group AG', 'MBGn.DE', 'MBG'],
  ['MQU_MDBI_MI_TR_INDEX', 'Mediobanca - Banca di Credito Finanziario S.p.A.', 'MDBI.MI', 'MB'],
  ['MQU_MEL_MC_TR_INDEX', 'Melia Hotels International, S.A.', 'MEL.MC', 'MEL'],
  ['MQU_METSO_HE_TR_INDEX', 'Metso Corporation', 'METSO.HE', 'METSO'],
  ['MQU_MICP_PA_TR_INDEX', 'Cie Generale des Etablissements Michelin SA', 'MICP.PA', 'ML'],
  ['MQU_MONC_MI_TR_INDEX', 'Moncler SpA', 'MONC.MI', 'MONC'],
  ['MQU_MRCG_DE_TR_INDEX', 'Merck KGaA', 'MRCG.DE', 'MRK'],
  ['MQU_MRL_MC_TR_INDEX', 'MERLIN Properties SOCIMI, S.A.', 'MRL.MC', 'MRL'],
  ['MQU_MT_AS_TR_INDEX', 'ArcelorMittal SA', 'MT.AS', 'MT'],
  ['MQU_MTXGn_DE_TR_INDEX', 'MTU Aero Engines AG', 'MTXGn.DE', 'MTX'],
  ['MQU_MUVGn_DE_TR_INDEX', 'Munich Reinsurance Company', 'MUVGn.DE', 'MUV2'],
  ['MQU_NDASE_ST_TR_INDEX', 'Nordea Bank Abp', 'NDASE.ST', 'NDA'],
  ['MQU_NESN_S_TR_INDEX', 'Nestle S.A.', 'NESN.S', 'NESN'],
  ['MQU_NESTE_HE_TR_INDEX', 'Neste Corporation', 'NESTE.HE', 'NESTE'],
  ['MQU_NEXII_MI_TR_INDEX', 'Nexi S.p.A.', 'NEXII.MI', 'NEXI'],
  ['MQU_NOKIA_HE_TR_INDEX', 'Nokia Oyj', 'NOKIA.HE', 'NOKIA'],
  ['MQU_NOVN_S_TR_INDEX', 'Novartis AG', 'NOVN.S', 'NOVN'],
  ['MQU_NTGY_MC_TR_INDEX', 'Naturgy Energy Group, S.A.', 'NTGY.MC', 'NTGY'],
  ['MQU_ORAN_PA_TR_INDEX', 'Orange SA', 'ORAN.PA', 'ORA'],
  ['MQU_OREP_PA_TR_INDEX', "L'Oreal S.A.", 'OREP.PA', 'OR'],
  ['MQU_ORNBV_HE_TR_INDEX', 'Orion Oyj Class B', 'ORNBV.HE', 'ORNBV'],
  ['MQU_OUT1V_HE_TR_INDEX', 'Outokumpu Oyj', 'OUT1V.HE', 'OUT1V'],
  ['MQU_P911_p_DE_TR_INDEX', 'Porsche AG', 'P911_p.DE', 'P911'],
  ['MQU_PERP_PA_TR_INDEX', 'Pernod Ricard SA', 'PERP.PA', 'RI'],
  ['MQU_PGHN_S_TR_INDEX', 'Partners Group Holding AG', 'PGHN.S', 'PGHN'],
  ['MQU_PIRC_MI_TR_INDEX', 'Pirelli & C. S.p.A.', 'PIRC.MI', 'PIRC'],
  ['MQU_PRTP_PA_TR_INDEX', 'Kering SA', 'PRTP.PA', 'KER'],
  ['MQU_PRX_AS_TR_INDEX', 'Prosus N.V. Class N', 'PRX.AS', 'PRX'],
  ['MQU_PRY_MI_TR_INDEX', 'Prysmian S.p.A.', 'PRY.MI', 'PRY'],
  ['MQU_PSHG_p_DE_TR_INDEX', 'Porsche Automobil Holding SE Pref', 'PSHG_p.DE', 'PAH3'],
  ['MQU_PST_MI_TR_INDEX', 'Poste Italiane SpA', 'PST.MI', 'PST'],
  ['MQU_QTCOM_HE_TR_INDEX', 'Qt Group Plc', 'QTCOM.HE', 'QTCOM'],
  ['MQU_RACE_MI_TR_INDEX', 'Ferrari NV', 'RACE.MI', 'RACE'],
  ['MQU_RECI_MI_TR_INDEX', 'Recordati Industria Chimica e Farmaceutica S.p.A.', 'RECI.MI', 'REC'],
  ['MQU_REDE_MC_TR_INDEX', 'Redeia Corporacion SA', 'REDE.MC', 'RED'],
  ['MQU_REP_MC_TR_INDEX', 'Repsol SA', 'REP.MC', 'REP'],
  ['MQU_RHMG_DE_TR_INDEX', 'Rheinmetall AG', 'RHMG.DE', 'RHM'],
  ['MQU_ROG_S_TR_INDEX', 'Roche Holding Ltd Dividend Right Cert.', 'ROG.S', 'ROG'],
  ['MQU_ROVI_MC_TR_INDEX', 'Laboratorios Farmaceuticos Rovi, S.A.', 'ROVI.MC', 'ROVI'],
  ['MQU_RWEG_DE_TR_INDEX', 'RWE AG', 'RWEG.DE', 'RWE'],
  ['MQU_SABE_MC_TR_INDEX', 'Banco de Sabadell SA', 'SABE.MC', 'SAB'],
  ['MQU_SAF_PA_TR_INDEX', 'Safran SA', 'SAF.PA', 'SAF'],
  ['MQU_SAMPO_HE_TR_INDEX', 'Sampo Oyj', 'SAMPO.HE', 'SAMPO'],
  ['MQU_SAN_MC_TR_INDEX', 'Banco Santander, S.A.', 'SAN.MC', 'SAN'],
  ['MQU_SAND_ST_TR_INDEX', 'Sandvik AB', 'SAND.ST', 'SAND'],
  ['MQU_SAPG_DE_TR_INDEX', 'SAP SE', 'SAPG.DE', 'SAP'],
  ['MQU_SASY_PA_TR_INDEX', 'Sanofi', 'SASY.PA', 'SAN'],
  ['MQU_SATG_p_DE_TR_INDEX', 'Sartorius AG Pref', 'SATG_p.DE', 'SRT3'],
  ['MQU_SBBb_ST_TR_INDEX', 'Samhallsbyggnadsbolaget I Norden AB Class B', 'SBBb.ST', 'SBBB'],
  ['MQU_SCAb_ST_TR_INDEX', 'Svenska Cellulosa AB SCA Class B', 'SCAb.ST', 'SCAB'],
  ['MQU_SCHN_PA_TR_INDEX', 'Schneider Electric SE', 'SCHN.PA', 'SU'],
  ['MQU_SCMN_S_TR_INDEX', 'Swisscom AG', 'SCMN.S', 'SCMN'],
  ['MQU_SCYR_MC_TR_INDEX', 'Sacyr SA', 'SCYR.MC', 'SCYR'],
  ['MQU_SEBa_ST_TR_INDEX', 'Skandinaviska Enskilda Banken AB Class A', 'SEBa.ST', 'SEBA'],
  ['MQU_SGEF_PA_TR_INDEX', 'VINCI SA', 'SGEF.PA', 'DG'],
  ['MQU_SGOB_PA_TR_INDEX', 'Compagnie de Saint-Gobain SA', 'SGOB.PA', 'SGO'],
  ['MQU_SHBa_ST_TR_INDEX', 'Svenska Handelsbanken AB Class A', 'SHBa.ST', 'SHBA'],
  ['MQU_SHLG_DE_TR_INDEX', 'Siemens Healthineers AG', 'SHLG.DE', 'SHL'],
  ['MQU_SIEGn_DE_TR_INDEX', 'Siemens Aktiengesellschaft', 'SIEGn.DE', 'SIE'],
  ['MQU_SIKA_S_TR_INDEX', 'Sika AG', 'SIKA.S', 'SIKA'],
  ['MQU_SINCH_ST_TR_INDEX', 'Sinch AB', 'SINCH.ST', 'SINCH'],
  ['MQU_SKFb_ST_TR_INDEX', 'SKF AB Class B', 'SKFb.ST', 'SKFB'],
  ['MQU_SLHN_S_TR_INDEX', 'Swiss Life Holding AG', 'SLHN.S', 'SLHN'],
  ['MQU_SLRS_MC_TR_INDEX', 'Solaria Energia y Medio Ambiente, S.A.', 'SLRS.MC', 'SLR'],
  ['MQU_SOGN_PA_TR_INDEX', 'Societe Generale S.A. Class A', 'SOGN.PA', 'GLE'],
  ['MQU_SOON_S_TR_INDEX', 'Sonova Holding AG', 'SOON.S', 'SOON'],
  ['MQU_SPMI_MI_TR_INDEX', 'Saipem S.p.A.', 'SPMI.MI', 'SPM'],
  ['MQU_SRENH_S_TR_INDEX', 'Swiss Re AG', 'SRENH.S', 'SREN'],
  ['MQU_SSABb_ST_TR_INDEX', 'SSAB AB Class B', 'SSABb.ST', 'SSABB'],
  ['MQU_STERV_HE_TR_INDEX', 'Stora Enso Oyj Class R', 'STERV.HE', 'STERV'],
  ['MQU_SWEDa_ST_TR_INDEX', 'Swedbank AB Class A', 'SWEDa.ST', 'SWEDA'],
  ['MQU_SY1G_DE_TR_INDEX', 'Symrise AG', 'SY1G.DE', 'SY1'],
  ['MQU_TCFP_PA_TR_INDEX', 'Thales SA', 'TCFP.PA', 'HO'],
  ['MQU_TEF_MC_TR_INDEX', 'Telefonica SA', 'TEF.MC', 'TEF'],
  ['MQU_TEL2b_ST_TR_INDEX', 'Tele2 AB Class B', 'TEL2b.ST', 'TEL2B'],
  ['MQU_TELIA_ST_TR_INDEX', 'Telia Company AB', 'TELIA.ST', 'TELIA'],
  ['MQU_TENR_MI_TR_INDEX', 'Tenaris S.A.', 'TENR.MI', 'TEN'],
  ['MQU_TIETO_HE_TR_INDEX', 'TietoEVRY Oyj', 'TIETO.HE', 'TIETO'],
  ['MQU_TLIT_MI_TR_INDEX', 'Telecom Italia S.p.A.', 'TLIT.MI', 'TIT'],
  ['MQU_TOKMAN_HE_TR_INDEX', 'Tokmanni Group Oyj', 'TOKMAN.HE', 'TOKMAN'],
  ['MQU_TRN_MI_TR_INDEX', 'Terna S.p.A.', 'TRN.MI', 'TRN'],
  ['MQU_TYRES_HE_TR_INDEX', 'Nokian Renkaat Oyj', 'TYRES.HE', 'TYRES'],
  ['MQU_UBSG_S_TR_INDEX', 'UBS Group AG', 'UBSG.S', 'UBSG'],
  ['MQU_UNI_MC_TR_INDEX', 'Unicaja Banco S.A.', 'UNI.MC', 'UNI'],
  ['MQU_UNPI_MI_TR_INDEX', 'Unipol Gruppo S.p.A.', 'UNPI.MI', 'UNI'],
  ['MQU_UPM_HE_TR_INDEX', 'UPM-Kymmene Oyj', 'UPM.HE', 'UPM'],
  ['MQU_VALMT_HE_TR_INDEX', 'Valmet Corp', 'VALMT.HE', 'VALMT'],
  ['MQU_VNAn_DE_TR_INDEX', 'Vonovia SE', 'VNAn.DE', 'VNA'],
  ['MQU_VOLVb_ST_TR_INDEX', 'Volvo AB Class B', 'VOLVb.ST', 'VOLVB'],
  ['MQU_VOWG_DE_TR_INDEX', 'Volkswagen AG', 'VOWG.DE', 'VOW'],
  ['MQU_WLN_PA_TR_INDEX', 'Worldline SA', 'WLN.PA', 'WLN'],
  ['MQU_WRT1V_HE_TR_INDEX', 'Wartsila Oyj Abp', 'WRT1V.HE', 'WRT1V'],
  ['MQU_ZALG_DE_TR_INDEX', 'Zalando SE', 'ZALG.DE', 'ZAL'],
  ['MQU_ZURN_S_TR_INDEX', 'Zurich Insurance Group Ltd', 'ZURN.S', 'ZURN'],
  ['MQU_VIE_PA_TR_INDEX', 'Veolia Environnement SA', 'VIE.PA', 'VIE'],
  [
    'MQU_URW_PA_TR_INDEX',
    'Unibail-Rodamco-Westfield SE Stapled Secs Cons of 1 Sh Unibail Rodamco + 1 Sh WFD Unib Rod',
    'URW.PA',
    'URW',
  ],
  ['MQU_CRH_L_TR_INDEX', 'CRH public limited company', 'CRH.L', 'CRH'],
  ['MQU_EDEN_PA_TR_INDEX', 'Edenred SA', 'EDEN.PA', 'EDEN'],
  ['MQU_RENA_PA_TR_INDEX', 'Renault SA', 'RENA.PA', 'RNO'],
  ['MQU_PUBP_PA_TR_INDEX', 'Publicis Groupe SA', 'PUBP.PA', 'PUB'],
  ['MQU_ALSO_PA_TR_INDEX', 'Alstom SA', 'ALSO.PA', 'ALO'],
];

export default data;
